import team_1 from "/public/images/team-1.png";
import team_2 from "/public/images/team-2.png";
import team_3 from "/public/images/team-3.png";
import team_4 from "/public/images/team-4.png";
import team_5 from "/public/images/team-5.png";
import team_6 from "/public/images/team-6.png";
import team_7 from "/public/images/team-7.png";
import team_8 from "/public/images/team-8.png";

const teamData = [
  {
    id: 1,
    img: team_1,
    name: "Dale Bryant",
    designation: "CEO & Founder",
  },
  {
    id: 2,
    img: team_2,
    name: "Dale Bryant",
    designation: "CFO",
  },
  {
    id: 3,
    img: team_3,
    name: "Dale Bryant",
    designation: "CTO & Co-founder",
  },
  {
    id: 4,
    img: team_4,
    name: "Dale Bryant",
    designation: "Head of Marketing",
  },
  {
    id: 5,
    img: team_5,
    name: "Dale Bryant",
    designation: "Business Analyst",
  },
  {
    id: 6,
    img: team_6,
    name: "Dale Bryant",
    designation: "Advisor, Investor  Member",
  },
  {
    id: 7,
    img: team_7,
    name: "Dale Bryant",
    designation: "Business Development",
  },
  {
    id: 8,
    img: team_8,
    name: "Dale Bryant",
    designation: "Full-stack Developer",
  },
];

export default teamData;
